import styled from 'styled-components'

export const File = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  padding: 5px 7px;
  margin: 0 5px 5px 0;
  background-color: var(--t-stroke-subtle);
  border-radius: 4px;
  cursor: pointer;
`

export const FileTitle = styled.div`
  padding-bottom: 2px;

  &:not(:last-child) {
    margin-right: 7px;
  }
`

export const FileDelete = styled.div`
  cursor: pointer;
  color: var(--t-file-chip-delete-button-text);

  svg {
    display: block;
  }
`
